import { styled } from '@mui/material/styles';
import Select from '@mui/material/Select';
var borderRadiusStyles = function borderRadiusStyles(edges, size, theme) {
  if (edges === 'rounded') {
    return 99;
  }
  if (edges === 'sharp') {
    return 0;
  }
  return size === 'small' ? theme.shape.borderRadius / 2 : theme.shape.borderRadius;
};
export var StyledSelect = styled(Select)(function (_ref) {
  var edges = _ref.edges,
    native = _ref.native,
    required = _ref.required,
    size = _ref.size,
    theme = _ref.theme,
    value = _ref.value,
    variant = _ref.variant;
  return {
    margin: 0,
    color: native && value === '' ? theme.palette.grey.main : null,
    borderRadius: borderRadiusStyles(edges, size, theme),
    '& .MuiSelect-select:focus': {
      borderRadius: 'inherit'
    },
    '& .MuiSelect-icon': {
      top: 'calc(50% - 12px)'
    },
    '&.MuiInputBase-root': {
      border: variant === 'filled' ? "2px solid transparent" : null
    },
    '& .MuiFilledInput-root': {
      backgroundColor: theme.palette.grey.transparent
    },
    '& .MuiChip-root': {
      height: size === 'small' ? 'auto' : null,
      '& .MuiChip-deleteIcon': {
        marginRight: size === 'small' ? 0 : null
      }
    },
    '& .MuiSelect-select': {
      padding: size === 'small' ? theme.spacing(1, 8, 1, 2) + " !important" : theme.spacing(2.8, 8, 2.8, 4) + " !important",
      minHeight: 24
    },
    '& .Mui-focused': {
      border: variant === 'filled' ? "2px solid " + (required ? theme.palette.secondary.main : null) : null
    },
    '& .MuiOutlinedInput-notchedOutline, &:hover .MuiOutlinedInput-notchedOutline': {
      borderColor: required && !value ? theme.palette.secondary.main : null
    }
  };
});
export var StyledNativePlaceholder = styled('div')(function (_ref2) {
  var allowEmpty = _ref2.allowEmpty,
    native = _ref2.native,
    placeholder = _ref2.placeholder,
    size = _ref2.size,
    theme = _ref2.theme,
    value = _ref2.value;
  if (native && placeholder && value === '' && !allowEmpty) {
    return {
      '& .MuiInputBase-root:before': {
        color: theme.palette.grey.main,
        position: 'absolute',
        display: 'block',
        pointerEvents: 'none',
        content: "\"" + placeholder + "\"",
        padding: size === 'small' ? theme.spacing(1, 8, 1, 2) : theme.spacing(3, 8, 3, 4)
      }
    };
  }
  return null;
});
export var StyledPlaceholder = styled('span')(function (_ref3) {
  var theme = _ref3.theme;
  return {
    color: theme.palette.grey.main
  };
});